
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d0dbf2f4\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/purchase.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./toBeVerifyDelivery.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d0dbf2f4\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./toBeVerifyDelivery.vue"),
  /* scopeId */
  "data-v-d0dbf2f4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/delivery/toBeVerifyDelivery.vue
// module id = 1749
// module chunks = 0